import { REDUCER_KEY_RESULTS_PREVIEW } from './constants';

export const resultsPreviewState = (state) => state.get(REDUCER_KEY_RESULTS_PREVIEW);
export const previewItems = (state) => resultsPreviewState(state).previewItems;
export const resultsMap = (state) => resultsPreviewState(state).resultsMap;
export const resultsByQueryId = (state, { queryId }) => resultsMap(state)[queryId];
